import { ReactNode } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { ButtonAfterConfig } from '@/shared/lib/forms/form-wrapper.types';
import { useSjActions } from '@/shared/lib/sj-orm/hooks/useSjActions';
import { Select } from '@/shared/uikitV2/Select';
import { Option } from '@/shared/uikitV2/Select/types';

import { FieldButton } from './FieldButton';

type BeneficiaryItem = {
  id: string;
  name?: string;
  nickname?: string;
  nickName?: string;
  shortname?: string;
};

type SelectPidBeneficiaryV2Props<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues, unknown>;
  buttonAfterConfig?: ButtonAfterConfig;
  name: Path<TFieldValues>;
  required: string | boolean;
  label: string;
  buttonAfterLabel?: ReactNode;
  disabled?: boolean;
  handleFieldAction?: () => void;
};

export const SelectPidBeneficiaryV2 = <TFieldValues extends FieldValues = FieldValues>({
  control,
  buttonAfterConfig,
  name,
  required,
  label,
  buttonAfterLabel,
  disabled,
  handleFieldAction,
}: SelectPidBeneficiaryV2Props<TFieldValues>) => {
  const sjBeneficiaries = useSjActions('beneficiaries');

  const collections = sjBeneficiaries.findMany(() => true) ?? [];
  const apiBeneficiaries: Option[] =
    collections.map((item: BeneficiaryItem) => ({
      value: item.id,
      content: {
        label: (item.name || item.nickName || item.nickname || item.shortname) ?? '',
      },
    })) ?? [];

  const beneficiaries = [{ value: 'me', content: { label: 'Me' } } as Option, ...apiBeneficiaries];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: buttonAfterConfig ? '0' : '8px' }}>
      <Controller
        name={name}
        control={control}
        rules={{ required }}
        render={({ field, fieldState }) => {
          return (
            <>
              <Select
                status={fieldState.error ? 'error' : 'default'}
                errorText={fieldState.error?.message}
                options={beneficiaries}
                label={label}
                required={Boolean(required)}
                {...field}
                disabled={disabled}
                value={field.value ?? ''}
              />
              {buttonAfterConfig && buttonAfterConfig.action && (
                <FieldButton
                  onClick={handleFieldAction}
                  disabled={disabled}
                  type={buttonAfterConfig.type || 'text'}
                >
                  {buttonAfterLabel}
                </FieldButton>
              )}
            </>
          );
        }}
      />
    </div>
  );
};
